import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { DataUtils } from 'app/core/util/data-util.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
@Component({
  selector: 'cbic-international-travellers',
  templateUrl: './international-travellers.component.html',
  styleUrls: ['./international-travellers.component.scss']
})
export class InternationalTravellersComponent implements OnInit {

  guideList?: ICbicContentMst[];
  buggageRules?: ICbicContentMst[];
  atitthiDataList?: ICbicContentMst[];
  othersList?: ICbicContentMst[];
  flag : any ;
  color:any;
  contentTypeId:any;
  guideNewList:any;
  PdfDataList: any;
  buggageRulesNewList:any;
  PdfDataListbagger:any;
  othersListNewList:any;
  PdfDataListOther:any;
  contentTypeIdOther:any;

  constructor(private sessionStorageService: SessionStorageService,private contentMstService: CbicContentMstService ,
    private changeLnService: ChangeLanguageService , private cbicDocMstService: CbicDocMstService,private http: HttpClient,  private dataUtils: DataUtils) { }

    isDataAvailable() {
      let dataAvailable = true;
      dataAvailable &&= this.guideList != null && this.guideList.length !== 0;
      if (dataAvailable) {
        dataAvailable &&= this.buggageRules != null && this.buggageRules.length !== 0;
      }
      if (dataAvailable) {
        dataAvailable &&= this.atitthiDataList != null && this.atitthiDataList.length !== 0;
      }
      if (dataAvailable) {
        dataAvailable &&= this.othersList != null && this.othersList.length !== 0;
      }
      
      return dataAvailable;
    };
  ngOnInit(): void {
    this.getGuideForTravellers();
    this.getBuggageRules();
    this.getAtithi();
    this.getOthers();
    this.color = this.sessionStorageService.retrieve('colr');
  }

  getGuideForTravellers() :void{
    this.contentMstService.getContentData('Guide-for-Travellers').subscribe(
      (res : HttpResponse<ICbicContentMst[]>) => {
        if(res.body){
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
          this.guideList = res.body; 
          this.contentTypeId=40
          this.fetchListOfChildDoc(this.guideList,this.contentTypeId);
        }
      }
    )
}
fetchListOfChildDoc(guideList:any,contentTypeId:any): void {
  if (this.guideList) {
    this.guideNewList = [];
    for (let i = 0; i < this.guideList.length; i++) {
      this.guideNewList[i] = Number(this.guideList[i].id) ;

      }

  }
  this.cbicDocMstService.gettickerDocList(this.guideNewList,contentTypeId).subscribe(
    (data: HttpResponse<ICbicDocMst[] >) => {
      if (data.body) {
        this.PdfDataList = data.body;
      }
    })
}

getBuggageRules() :void{
  this.contentMstService.getContentData('Baggage-Rules').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.buggageRules = res.body;
        this.contentTypeId=41
        this.fetchListbuggageRules(this.buggageRules,this.contentTypeId);
      }
    }
  )
}

fetchListbuggageRules(buggageRules:any,contentTypeId:any): void {
  if (this.buggageRules) {
    this.buggageRulesNewList = [];
    for (let i = 0; i < this.buggageRules.length; i++) {
      this.buggageRulesNewList[i] = Number(this.buggageRules[i].id) ;

      }

  }
  this.cbicDocMstService.getbuggageRulesNew(this.buggageRulesNewList,contentTypeId).subscribe(
    (data: HttpResponse<ICbicDocMst[] >) => {
      if (data.body) {
        this.PdfDataListbagger = data.body;
      }
    })
}

getAtithi() :void{
  this.contentMstService.getContentData('Atithi-@Indian-Customs').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.atitthiDataList = res.body;
      }
    }
  )
}

getOthers() :void{
  this.contentMstService.getContentData('Other-International').subscribe(
    (res : HttpResponse<ICbicContentMst[]>) => {
      if(res.body){
        const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag = 'Hi';
          } else {
            this.flag = 'En';
          }
        this.othersList = res.body;
        this.contentTypeIdOther=43
        this.fetchListOther(this.othersList,this.contentTypeIdOther);
      }
    }
  )
}

fetchListOther(othersList:any,contentTypeIdOther:any): void {
  if (this.othersList) {
    this.othersListNewList = [];
    for (let i = 0; i < this.othersList.length; i++) {
      this.othersListNewList[i] = Number(this.othersList[i].id) ;

      }

  }
  this.cbicDocMstService.getfatchOther(this.othersListNewList,contentTypeIdOther).subscribe(
    (data: HttpResponse<ICbicDocMst[] >) => {
      if (data.body) {
        this.PdfDataListOther = data.body;
      }
    })
}



viewDocuments(contTypeID: number): void {
  this.cbicDocMstService.fetchMemberCustomsPdfPath(contTypeID)
    .subscribe(
      (res: HttpResponse<ICbicDocMst>) => {
        this.ViewPdf(res.body?.filePathEn)
      }
    )
}

ViewPdf(path1: any): void {
  //  alert(path1);
  if (path1) {
    const arr = path1.split('.');
    if ((arr[arr.length - 1] === 'pdf') || (arr[arr.length - 1] === 'PDF')) {
      this.http.get("content/pdf/" + String(path1), { responseType: 'text' })
        .subscribe((res) => {
          if (res) {
            const json = JSON.parse(res);
            // const fileURL = 'data:application/pdf;base64,' + String(json.data);
            this.dataUtils.openFile(String(json.data), "application/pdf");
          }
          else {
            alert("No data found");
          }
        }
        );
    } 
  else if ((arr[arr.length - 1] === 'xls')) {

      this.http.get("content/anotherfile/" + String(path1), { responseType: 'text' })
        .subscribe((res1) => {
          if (res1) {
            const json = JSON.parse(res1);
            // const fileURL = 'data:application/pdf;base64,' + String(json.data);
            this.dataUtils.openFile(String(json.data), "application/vnd.ms-excel");
          }
          else {
            alert("No data found");
          }

        }
        );
    }
   else if ((arr[arr.length - 1] === 'xlsx')) {

      this.http.get("content/anotherfile/" + String(path1), { responseType: 'text' })
        .subscribe((res1) => {
          if (res1) {
            const json = JSON.parse(res1);
            // const fileURL = 'data:application/pdf;base64,' + String(json.data);
            this.dataUtils.openFile(String(json.data), "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
          else {
            alert("No data found");
          }

        }
        );
    }
    else {
      const arr1 = path1.split('//');
      if(arr1 !== undefined && ((arr1[arr1.length - 2]) === 'https:' || (arr1[arr1.length - 2]) === 'http:')){
        window.open(path1, "_blank");
      }
      else
      {
        if (confirm("No preview available press ok for download the file")) {
          alert("download file successfully");
        }
      }
    }

  }
  else { alert("No data found"); }
}



}
